import { Story } from "chq";

const isMultiImageStory = (story: Story) => {
  if (!story) return false;

  const { media } = story;

  if (media.mediaType === "video") {
    return false;
  }

  if (story.visuals) {
    return story.visuals.length > 1;
  }

  return false;
};

export default isMultiImageStory;
